import { useEffect, type ReactNode } from 'react'

import { useAuth } from 'src/auth'
import { useEviePageFacts } from 'src/components/Evie/page/hooks/useEviePageFacts'
import { useParams } from 'src/platform/router'
import { tryEnablingHeartbeat } from 'src/utils/activityHeartbeat'
import { setFullStoryUserVars } from 'src/utils/fullStory'

import { EviePageFactsContext } from './eviePageFactsContext'

/** Common applicant lifecycle. The page selects its complete route shell only
 * after the single enrollment read resolves; no UI framework is mounted here. */
const ApplicantSessionLayout = ({ children }: { children: ReactNode }) => {
  const { currentUser } = useAuth()
  const { workflowId, applicantId } = useParams()
  const parsedApplicantId = applicantId ? +applicantId : undefined
  tryEnablingHeartbeat(parsedApplicantId)
  const eviePageFacts = useEviePageFacts({
    applicantId: parsedApplicantId ?? 0,
    skip: !workflowId || !applicantId,
  })
  useEffect(() => {
    if (currentUser) window.Intercom('update', { hide_default_launcher: true })
  }, [currentUser])
  useEffect(() => {
    if (currentUser && workflowId && applicantId) {
      setFullStoryUserVars(workflowId, applicantId)
    }
  }, [currentUser, workflowId, applicantId])
  return (
    <EviePageFactsContext.Provider value={eviePageFacts}>
      {children}
    </EviePageFactsContext.Provider>
  )
}
export default ApplicantSessionLayout
